import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f850fa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "table-header-fixed",
  ref: "tableHeaderRef"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "index-header"
}
const _hoisted_4 = {
  key: 0,
  class: "settings-icon settings-icon-text-only"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "sort-icon"
}
const _hoisted_8 = {
  key: 3,
  class: "sort-icon"
}
const _hoisted_9 = {
  key: 0,
  class: "loading-mask"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["data-symbol", "onClick", "onDblclick"]
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 6 }
const _hoisted_15 = { key: 8 }
const _hoisted_16 = { key: 9 }
const _hoisted_17 = { key: 10 }
const _hoisted_18 = { key: 11 }
const _hoisted_19 = { key: 12 }
const _hoisted_20 = { key: 13 }
const _hoisted_21 = { key: 15 }
const _hoisted_22 = {
  key: 16,
  style: {"color":"#fecc0d"}
}
const _hoisted_23 = { key: 17 }
const _hoisted_24 = { key: 18 }
const _hoisted_25 = { key: 19 }
const _hoisted_26 = { key: 20 }
const _hoisted_27 = { key: 21 }
const _hoisted_28 = { key: 24 }
const _hoisted_29 = { key: 29 }
const _hoisted_30 = { key: 30 }
const _hoisted_31 = { key: 31 }
const _hoisted_32 = { key: 32 }
const _hoisted_33 = { key: 33 }
const _hoisted_34 = { key: 34 }
const _hoisted_35 = { key: 35 }
const _hoisted_36 = { key: 36 }
const _hoisted_37 = { key: 37 }
const _hoisted_38 = { key: 38 }
const _hoisted_39 = { key: 39 }
const _hoisted_40 = ["onDblclick"]
const _hoisted_41 = {
  key: 0,
  class: "agency-gold-trigger"
}
const _hoisted_42 = {
  key: 1,
  class: "agency-gold-view"
}
const _hoisted_43 = {
  key: 2,
  class: "empty-text"
}
const _hoisted_44 = { key: 41 }
const _hoisted_45 = {
  key: 0,
  class: "ai-interp-cell"
}
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  key: 1,
  class: "empty-text"
}
const _hoisted_48 = {
  key: 0,
  class: "load-more-row"
}
const _hoisted_49 = ["colspan"]
const _hoisted_50 = {
  key: 0,
  class: "loading-text"
}
const _hoisted_51 = {
  key: 1,
  class: "no-more-text"
}
const _hoisted_52 = {
  key: 1,
  class: "empty-row"
}
const _hoisted_53 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSettingsPanel = _resolveComponent("HeaderSettingsPanel")!
  const _component_DragonSignalBacktest = _resolveComponent("DragonSignalBacktest")!
  const _component_DragonHunterBacktest = _resolveComponent("DragonHunterBacktest")!
  const _component_QuantGoldBacktest = _resolveComponent("QuantGoldBacktest")!
  const _component_Nodata = _resolveComponent("Nodata")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pool-table", _ctx.theme]),
    ref: "tableWrapperRef"
  }, [
    ((!_ctx.isDragonSignal || _ctx.mengzhuSignalType !== 'backtest') && (!_ctx.isDragonHunter || _ctx.dragonHunterMainTab !== 'dataTrack') && (!_ctx.isQuantGold || _ctx.quantGoldMainTab !== 'dataTrack'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("table", null, [
            _createElementVNode("colgroup", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayColumns, (col) => {
                return (_openBlock(), _createElementBlock("col", {
                  key: col.key,
                  style: _normalizeStyle({ width: typeof col.width === 'number' ? col.width + 'px' : col.width })
                }, null, 4))
              }), 128))
            ]),
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayColumns, (col, colIndex) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: col.key,
                    class: _normalizeClass([
              _ctx.getAlignClass(col.align),
              { 'fixed-left': col.fixed === 'left', 'sortable': col.sortable }
            ]),
                    style: _normalizeStyle(col.fixed === 'left' ? { left: _ctx.getFixedLeft(colIndex) + 'px' } : {}),
                    onClick: ($event: any) => (col.sortable ? _ctx.handleSort(col.key) : null)
                  }, [
                    (col.key === 'index')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                          _createTextVNode(_toDisplayString(col.title) + " ", 1),
                          (_ctx.isXpOs)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "序"))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: "settings-icon",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openHeaderSettings && _ctx.openHeaderSettings(...args)), ["stop"])),
                                onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.settingsIconHover = true)),
                                onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.settingsIconHover = false)),
                                title: "表头设置"
                              }, [
                                _createElementVNode("img", {
                                  src: _ctx.settingsIconSrc,
                                  width: "14",
                                  height: "14",
                                  alt: "设置"
                                }, null, 8, _hoisted_5)
                              ], 32))
                        ]))
                      : (col.key === 'goldSignal' && _ctx.isAgencyIntraday)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "agency-gold-header",
                            onDblclick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleAgencyGoldHeaderDblClick && _ctx.handleAgencyGoldHeaderDblClick(...args)), ["stop"]))
                          }, [
                            (!_ctx.agencyHasQuantPermission)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.agencyGoldLockSrc,
                                  class: "agency-gold-lock",
                                  width: "12",
                                  height: "12",
                                  alt: "锁定"
                                }, null, 8, _hoisted_6))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(col.title) + " ", 1),
                            (col.sortable && _ctx.sortField === col.key)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.sortOrder === 'ascend' ? '↑' : '↓'), 1))
                              : _createCommentVNode("", true)
                          ], 32))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(col.title), 1)
                          ], 64)),
                    (col.sortable && _ctx.sortField === col.key && !(col.key === 'goldSignal' && _ctx.isAgencyIntraday))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.sortOrder === 'ascend' ? '↑' : '↓'), 1))
                      : _createCommentVNode("", true)
                  ], 14, _hoisted_2))
                }), 128))
              ])
            ])
          ])
        ], 512))
      : _createCommentVNode("", true),
    _createVNode(_component_HeaderSettingsPanel, {
      visible: _ctx.headerSettingsVisible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.headerSettingsVisible) = $event)),
      columns: _ctx.draggableColumns,
      defaultColumns: _ctx.defaultDraggableColumns,
      theme: _ctx.theme as 'light' | 'dark',
      onApply: _ctx.handleHeaderSettingsApply,
      onCancel: _ctx.handleHeaderSettingsCancel
    }, null, 8, ["visible", "columns", "defaultColumns", "theme", "onApply", "onCancel"]),
    (_ctx.isDragonSignal && _ctx.mengzhuSignalType === 'backtest')
      ? (_openBlock(), _createBlock(_component_DragonSignalBacktest, {
          key: 1,
          theme: _ctx.theme,
          signalType: _ctx.dragonSignalStrategyCode
        }, null, 8, ["theme", "signalType"]))
      : _createCommentVNode("", true),
    (_ctx.isDragonHunter && _ctx.dragonHunterMainTab === 'dataTrack')
      ? (_openBlock(), _createBlock(_component_DragonHunterBacktest, {
          key: 2,
          theme: _ctx.theme,
          nameType: _ctx.dragonHunterSubTab
        }, null, 8, ["theme", "nameType"]))
      : _createCommentVNode("", true),
    (_ctx.isQuantGold && _ctx.quantGoldMainTab === 'dataTrack')
      ? (_openBlock(), _createBlock(_component_QuantGoldBacktest, {
          key: 3,
          theme: _ctx.theme
        }, null, 8, ["theme"]))
      : _createCommentVNode("", true),
    ((!_ctx.isDragonSignal || _ctx.mengzhuSignalType !== 'backtest') && (!_ctx.isDragonHunter || _ctx.dragonHunterMainTab !== 'dataTrack') && (!_ctx.isQuantGold || _ctx.quantGoldMainTab !== 'dataTrack'))
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "table-container",
          ref: "tableBodyRef",
          onScroll: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
          style: _normalizeStyle(_ctx.tableContainerStyle)
        }, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
            : _createCommentVNode("", true),
          _createElementVNode("table", null, [
            _createElementVNode("colgroup", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayColumns, (col) => {
                return (_openBlock(), _createElementBlock("col", {
                  key: col.key,
                  style: _normalizeStyle({ width: typeof col.width === 'number' ? col.width + 'px' : col.width })
                }, null, 4))
              }), 128))
            ]),
            _createElementVNode("tbody", null, [
              (_ctx.dataSource.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSource, (record, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: record.symbol + '_' + (record.selectTime || record.dateTime || record.feedTimestamp || index),
                        "data-symbol": record.symbol,
                        onClick: ($event: any) => (_ctx.handleRowClick(record, $event)),
                        onDblclick: ($event: any) => (_ctx.handleRowDblClick(record, $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayColumns, (col, colIndex) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: col.key,
                            class: _normalizeClass([
                `col-${col.key}`,
                { 'fixed-left': col.fixed === 'left' },
                _ctx.getCellClass()
              ]),
                            style: _normalizeStyle(_ctx.getCellStyle(col, colIndex, record))
                          }, [
                            (col.key === 'index')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(index + 1), 1)
                                ], 64))
                              : (col.key === 'symbol')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_ctx.getDisplayCode(record.symbol)), 1)
                                  ], 64))
                                : (col.key === 'name')
                                  ? (_openBlock(), _createElementBlock("strong", _hoisted_13, _toDisplayString(_ctx.getDisplayName(record.name)), 1))
                                  : (col.key === 'macd')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        _createTextVNode(_toDisplayString(_ctx.getMacdText(record.macd)), 1)
                                      ], 64))
                                    : (col.key === 'amount' && !_ctx.isMengzhuTrend && !_ctx.isDragonSignal && !_ctx.isDragonHunter && !_ctx.isQuantGold)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                          _createTextVNode(_toDisplayString(_ctx.getAmountText(record.amount)), 1)
                                        ], 64))
                                      : (col.key === 'amount' && (_ctx.isMengzhuTrend || _ctx.isDragonSignal || _ctx.isDragonHunter || _ctx.isQuantGold))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                            _createTextVNode(_toDisplayString(_ctx.getMengzhuAmountText(record.amount)), 1)
                                          ], 64))
                                        : (col.key === 'plateName' && _ctx.isQuantGold)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(record.plateName || record.ext?.plateName || '--'), 1))
                                          : (col.key === 'plateName' && !_ctx.isMengzhuTrend && !_ctx.isDragonHunter && !_ctx.isAgencyIntraday)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                                (record.plateType)
                                                  ? (_openBlock(), _createElementBlock("span", {
                                                      key: 0,
                                                      class: _normalizeClass(['plate-tag', { 'plate-tag-unselected': String(record.plateType) === '0' || !record.plateType }]),
                                                      style: _normalizeStyle(_ctx.getPlateStyle(record.plateType))
                                                    }, _toDisplayString(_ctx.getPlateText(record.plateType, record.plateName)), 7))
                                                  : (_openBlock(), _createElementBlock("span", {
                                                      key: 1,
                                                      class: _normalizeClass(['plate-tag', { 'plate-tag-unselected': String(record.plateType) === '0' || !record.plateType }])
                                                    }, _toDisplayString(_ctx.getPlateText(record.plateType, record.plateName)), 3))
                                              ], 64))
                                            : (col.key === 'plateName' && _ctx.isMengzhuTrend)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(record.plate?.name || record.plateName || '--'), 1))
                                              : (col.key === 'plateName' && _ctx.isDragonHunter)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(record.plateName || '--'), 1))
                                                : (col.key === 'dragonPlateName')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(record.dragonPlateName || record.ext?.plateName || '--'), 1))
                                                  : (col.key === 'stockHot')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.formatStockHot(record.stockHot)), 1))
                                                    : (col.key === 'symbolHot')
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.formatHunterHot(record.symbolHot)), 1))
                                                      : (col.key === 'plateHot')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.formatHunterHot(record.plateHot)), 1))
                                                        : (col.key === 'hunterSelectType')
                                                          ? (_openBlock(), _createElementBlock("span", {
                                                              key: 14,
                                                              style: _normalizeStyle({ color: _ctx.getHunterSelectTypeColor(record.selectType) })
                                                            }, _toDisplayString(_ctx.getHunterSelectTypeText(record.selectType)), 5))
                                                          : (col.key === 'hunterDateTime')
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.formatHunterDate(record.dateTime || record.selectTime)), 1))
                                                            : (col.key === 'upSpaceStar')
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.formatUpSpaceStar(record.upSpaceStar)), 1))
                                                              : (col.key === 'sellTime' && _ctx.isQuantGold && _ctx.quantGoldSubTab === 'entrySignal')
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.formatQuantGoldDate(record.sellTime)), 1))
                                                                : (col.key === 'entryTime' && _ctx.isQuantGold && _ctx.quantGoldSubTab === 'exitSignal')
                                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.formatQuantGoldDate(record.entryTime)), 1))
                                                                  : (col.key === 'coverShortTime' && _ctx.isQuantGold && _ctx.quantGoldSubTab === 'shortSignal')
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.formatQuantGoldDate(record.coverShortTime)), 1))
                                                                    : (col.key === 'shortTime' && _ctx.isQuantGold && _ctx.quantGoldSubTab === 'coverShortSignal')
                                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.formatQuantGoldDate(record.shortTime)), 1))
                                                                      : (col.key === 'exitDate')
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.formatQuantGoldDate(record.exitDate)), 1))
                                                                        : (col.key === 'highPct' && _ctx.isQuantGold)
                                                                          ? (_openBlock(), _createElementBlock("span", {
                                                                              key: 22,
                                                                              style: _normalizeStyle({ color: _ctx.getQuantGoldPctColor(record.highPct) })
                                                                            }, _toDisplayString(_ctx.formatCellValue(record.highPct, 'percent')), 5))
                                                                          : (col.key === 'cumRate' && _ctx.isQuantGold)
                                                                            ? (_openBlock(), _createElementBlock("span", {
                                                                                key: 23,
                                                                                style: _normalizeStyle({ color: _ctx.getQuantGoldPctColor(record.cumRate) })
                                                                              }, _toDisplayString(_ctx.formatCellValue(record.cumRate, 'percent')), 5))
                                                                            : (col.key === 'cumRate' && _ctx.isMengzhuTrend)
                                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.formatMengzhuCumRate(record.cumRate, _ctx.currentMengzhuMainTab)), 1))
                                                                              : (col.key === 'day5Rate')
                                                                                ? (_openBlock(), _createElementBlock("span", {
                                                                                    key: 25,
                                                                                    style: _normalizeStyle({ color: _ctx.getMengzhuChangeColor(record.day5Rate) })
                                                                                  }, _toDisplayString(_ctx.formatCellValue(record.day5Rate,
                    'percent')), 5))
                                                                                : (col.key === 'state')
                                                                                  ? (_openBlock(), _createElementBlock("span", {
                                                                                      key: 26,
                                                                                      style: _normalizeStyle({ color: _ctx.getChipStateColorStyle(record.state, record.stateColor) })
                                                                                    }, _toDisplayString(record.state || '--'), 5))
                                                                                  : (col.key === 'shape')
                                                                                    ? (_openBlock(), _createElementBlock("span", {
                                                                                        key: 27,
                                                                                        style: _normalizeStyle({ color: _ctx.getChipShapeColorStyle() })
                                                                                      }, _toDisplayString(record.shape || '--'), 5))
                                                                                    : (col.key === 'inPoolTime')
                                                                                      ? (_openBlock(), _createElementBlock("span", {
                                                                                          key: 28,
                                                                                          style: _normalizeStyle({ color: _ctx.getInPoolTimeColorStyle() })
                                                                                        }, _toDisplayString(_ctx.formatInPoolTimeValue(record.inPoolTime)), 5))
                                                                                      : (col.key === 'fund')
                                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.formatMengzhuFund(record.fund)), 1))
                                                                                        : (col.key === 'sellTime' && _ctx.isMengzhuTrend)
                                                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.formatMengzhuDateValue(record.sellTime)), 1))
                                                                                          : (col.key === 'buyTime')
                                                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.formatMengzhuDateValue(record.buyTime)), 1))
                                                                                            : (col.key === 'maxRate' && _ctx.isMengzhuTrend)
                                                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.formatMengzhuMaxRate(record.maxRate)), 1))
                                                                                              : (col.key === 'lastPx')
                                                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.isAgencyIntraday ? _ctx.formatAgencyLastPx(record) : _ctx.formatLastPx(record.lastPx, record.market)), 1))
                                                                                                : (col.key === 'pxChangRate')
                                                                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.formatPxChangRate(record.lastPx, record.pxChangRate)), 1))
                                                                                                  : (col.key === 'selectRate')
                                                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.formatSelectRate(record.selectRate)), 1))
                                                                                                    : (col.key === 'mainInRate' && _ctx.isAgencyIntraday)
                                                                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.formatAgencyRate(record.mainInRate)), 1))
                                                                                                      : (col.key === 'mainOutRate' && _ctx.isAgencyIntraday)
                                                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.formatAgencyRate(record.mainOutRate)), 1))
                                                                                                        : (col.key === 'retailInRate' && _ctx.isAgencyIntraday)
                                                                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.formatAgencyRate(record.retailInRate)), 1))
                                                                                                          : (col.key === 'retailOutRate' && _ctx.isAgencyIntraday)
                                                                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.formatAgencyRate(record.retailOutRate)), 1))
                                                                                                            : (col.key === 'goldSignal' && _ctx.isAgencyIntraday)
                                                                                                              ? (_openBlock(), _createElementBlock("span", {
                                                                                                                  key: 40,
                                                                                                                  class: "agency-gold-cell",
                                                                                                                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                                                                                                                  onDblclick: _withModifiers(($event: any) => (_ctx.handleAgencyGoldCellDblClick(record)), ["stop"])
                                                                                                                }, [
                                                                                                                  (record._agencyGoldDisplay === 'trigger')
                                                                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_41, "触发信号"))
                                                                                                                    : (record._agencyGoldDisplay === 'view')
                                                                                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, "立即查看"))
                                                                                                                      : (_openBlock(), _createElementBlock("span", _hoisted_43, "--"))
                                                                                                                ], 40, _hoisted_40))
                                                                                                              : (col.key === 'plateName' && _ctx.isAgencyIntraday)
                                                                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(record.plateName || '--'), 1))
                                                                                                                : (col.key === 'reason')
                                                                                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 42 }, [
                                                                                                                      (record.reason)
                                                                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                                                                                            _createElementVNode("span", {
                                                                                                                              class: "ai-interp-detail",
                                                                                                                              onClick: _withModifiers(($event: any) => (_ctx.openAiInterpDetail(record)), ["stop"])
                                                                                                                            }, "详情", 8, _hoisted_46)
                                                                                                                          ]))
                                                                                                                        : (_openBlock(), _createElementBlock("span", _hoisted_47, "——"))
                                                                                                                    ], 64))
                                                                                                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 43 }, [
                                                                                                                      _createTextVNode(_toDisplayString(_ctx.formatCellValue(record[col.key], col.formatter, record.market)), 1)
                                                                                                                    ], 64))
                          ], 6))
                        }), 128))
                      ], 40, _hoisted_12))
                    }), 128)),
                    (_ctx.loadingMore || (!_ctx.hasMore && _ctx.dataSource.length >= 100))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_48, [
                          _createElementVNode("td", {
                            colspan: _ctx.displayColumns.length,
                            class: "load-more-cell"
                          }, [
                            (_ctx.loadingMore)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_50, "加载中..."))
                              : (!_ctx.hasMore)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_51, "没有更多数据了"))
                                : _createCommentVNode("", true)
                          ], 8, _hoisted_49)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_52, [
                      _createElementVNode("td", {
                        colspan: _ctx.displayColumns.length,
                        class: "empty-cell"
                      }, [
                        _createVNode(_component_Nodata, {
                          mode: "vertical",
                          customdesc: "暂无数据",
                          pagetheme: _ctx.theme
                        }, null, 8, ["pagetheme"])
                      ], 8, _hoisted_53)
                    ]))
                  : _createCommentVNode("", true)
            ])
          ])
        ], 36))
      : _createCommentVNode("", true)
  ], 2))
}